import Transitions from "components/@extended/Transitions";
import { CardContent, ClickAwayListener, Paper, Popper,Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MainCard from "components/MainCard";
import { Divider, Grid, Typography } from "@mui/material";
import { useInstance, useAIEventHandler } from "easy-redux-http-call";
import { AI_getUserData } from "APIs/user";
import { AI_getProjectNames } from "APIs/project";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import LeaveDashBoard from "pages/dashboard/LeaveDashBoard";
import { useEffect, useState } from "react";
import moment from "moment";
import { Dialog } from "../../../node_modules/@mui/material/index";
import { AI_getNotification } from "APIs/notification";

const useStyle = makeStyles((theme) => ({
  hrmsNotificationPaper: {
    boxShadow: theme.customShadows.z1,
    width: 450,
    minWidth: 240,
    marginRight: "10px",
    maxHeight: "300px",
    overflowY: "auto",
    [theme.breakpoints.down("md")]: {
      maxWidth: 250,
    },
  },
  hrmsNotification: {
    paddingTop: "10px",
    textAlign: "start",
    cursor: "pointer",
  },
  hrNotify: {
    borderRadius: "14px",
    padding: "0px 12px",
    margin: "10px 0px",
  },
  hrDate: {
    color: "gray",
  },
  hrShowAllNotification: {
    display: "flex",
    justifyContent: "center",
  },
  paper: {
    padding: theme.spacing(2),
    maxWidth: 450,
    maxHeight: 300,
    overflowY: "auto",
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
  },
  notification: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  date: {
    color: "gray",
  },
  divider: {
    margin: `${theme.spacing(1)}px 0`,
  },
}));
export default function AdminNotification({
  data = [],
  open,
  setOpen,
  anchorEl,
  handleClose,
}) {
  const theme = useTheme();
  const classes = useStyle();
  const getUserData = useInstance(AI_getUserData);
  const projectNamesEmployee = useInstance(AI_getProjectNames);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState({
    leave: false,
    type: "",
  });
  const handleClosePopup = () => {
    setOpen(false);
    navigate("/all-notifications");
  };
  const [projectNames, setProjectNames] = useState([]);

  const ShowNotification = () => {
    data &&
      Array.isArray(data) &&
      data?.map((data) => {
        return (
          <div>
            <Popper open={data}>
              <Grid>
                {data.length === 0 && (
                  <Typography variant="h5">
                    No alerts, smooth sailing projects!
                  </Typography>
                )}
                {data.length > 0 &&
                  data.map((notification) => (
                    <Grid
                      key={notification.id}
                      className={classes.hrNotify}
                      style={{
                        backgroundColor: !notification.is_read && "#fff3e0",
                      }}
                    >
                      <Grid
                        onClick={() =>
                          handleRedirect(
                            notification.employee_id,
                            notification.type,
                            notification // for custom
                          )
                        }
                        className={classes.hrmsNotification}
                      >
                        {notification.notification}
                      </Grid>
                      <p className={classes.hrDate}>
                        {moment(notification.createdAt).format("DD MMMM yyyy")}
                      </p>
                      <Divider />
                    </Grid>
                  ))}
                {/* SHOW ALL NOTIFICAION!  */}

                <Button
                  onclassName={classes.hrShowAllNotification}
                  variant=""
                  href="#outlined-buttons"
                  onClick={() => {
                    ShowNotification();
                  }}
                >
                  Show All Notification
                </Button>
              </Grid>
            </Popper>
          </div>
        );
      });
  };
  const handleCloseLeaveForAdmin = () => {
    setOpenDialog({
      leave: false,
    });
  };

  const handleRedirect = (id, type, data) => {

    setOpen(false);
    if (type === "leave") {
      if (getUserData?.data?.user?.is_access_to_employee) {
        // navigate(`employee/${data}/details`); // Dont Delete comment
        setOpenDialog({ leave: true, type: "leave" });
        localStorage.setItem("employee-view", "Leave / Extra-day");
        localStorage.setItem("activeMenuItem", "emplyoee-details");
        AI_getNotification.call()
      } else {
        navigate("/leave");
      }
    }
    if (type === "extra") {
      setOpenDialog({ leave: true, type: "extra" });
      AI_getNotification.call()
    }
    if (type === "completion") {
      navigate(`employee/${id}/details`);
      localStorage.setItem("activeMenuItem", "emplyoee-details");
    }
    if (type === "first_login") {
      navigate("/emplyoee");
      localStorage.setItem("employee", "Active");
    }

    if (type === "leave_action") {
      AI_getNotification.call()
      navigate("/leave");
    }
    if (type === "interview") {
      AI_getNotification.call()
      return navigate("/interview");
    }

    if (type === "share_credential") {
      AI_getNotification.call()
      return navigate("/credential");
    }

    if (type === "task_comment") {
      AI_getNotification.call()
      const statement = data.notification;
      let name = "";
      const lastCommaIndex = statement.lastIndexOf(",");
      const lastFullStopIndex = statement.lastIndexOf(".");
      if (lastCommaIndex !== -1 && lastFullStopIndex !== -1) {
        const projectName = statement.substring(
          lastCommaIndex + 1,
          lastFullStopIndex
        );
        name = projectName;
      }
      const project = projectNames?.find((proj) => proj?.title === name);
      return navigate(
        `/projects/${project?.project_id}/detail${
          data?.data_id ? `/${data.data_id}` : ""
        }`
      );
    }

    if (type === "task_assignment") {
      AI_getNotification.call()
      const statement = data?.notification;
      let name = "";
      const lastCommaIndex = statement.lastIndexOf(",");
      const lastFullStopIndex = statement.lastIndexOf(".");
      if (lastCommaIndex !== -1 && lastFullStopIndex !== -1) {
        const projectName = statement.substring(
          lastCommaIndex + 1,
          lastFullStopIndex
        );
        name = projectName;
      }
      const project = projectNames?.find((proj) => proj?.title === name);
      return navigate(
        `/projects/${project?.project_id}/detail${
          data?.data_id ? `/${data.data_id}` : ""
        }`
      );
    }
    if(type === "update_handover"){
      AI_getNotification.call()
      return navigate("/handover-dashboard")
    }
    if(type === "add_handover"){
      AI_getNotification.call()
      return navigate("/handover-dashboard") 
    }
  };

  useEffect(() => {
    AI_getNotification.call()
    AI_getProjectNames.call({
      params: {
        employee_id: getUserData?.data?.user?.id,
      },
    });
  }, []);

  useAIEventHandler(AI_getProjectNames, {
    onSuccess: (data) => {
      setProjectNames(projectNamesEmployee.data);
    },
  });
  const filteredData = data.filter(notification => notification.is_deleted !== '1');

  return (
    <>
      <Popper
        anchorEl={anchorEl}
        open={open}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 9],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="fade" in={open} {...TransitionProps}>
            <Paper className={classes.hrmsNotificationPaper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid>
                      {filteredData.length === 0 && (
                        <Typography variant="h5">
                          No alerts, smooth sailing projects!
                        </Typography>
                      )}
                      {filteredData.slice(0, 5).map((notification) => (
                        <Grid
                          key={notification.id}
                          className={classes.hrNotify}
                          style={{
                            backgroundColor: !notification.is_read && "#fff3e0",
                          }}
                        >
                          <Grid
                            onClick={() =>
                              handleRedirect(
                                notification.employee_id,
                                notification.type,
                                notification // for custom
                              )
                            }
                            className={classes.hrmsNotification}
                          >
                            {notification.notification}
                          </Grid>
                          <p className={classes.hrDate}>
                            {moment(notification.createdAt).format(
                              "DD MMMM yyyy"
                            )}
                          </p>
                          <Divider />
                        </Grid>
                      ))}
                      {data.length > 5 && (
                        <Grid className={classes.hrNotify}>
                          <Button
                            onClick={handleClosePopup}
                            className={classes.viewAllButton}
                          >
                            View All
                          </Button>
                        </Grid>
                      )}


                    </Grid>
                  </CardContent>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
      <LeaveDashBoard
        openStatus={openDialog.leave}
        handleCloseAction={handleCloseLeaveForAdmin}
        type={openDialog.type}
      />
    </>
  );
}
